import React from 'react';

import { TranslationsRoot } from 'modules/shared-menu/components/TranslationsRoot';

export const SharedMenuTranslationsPage = () => {
  return <TranslationsRoot />;
};
